export default "__VITE_ASSET__D2Sg8tvH__"